module.exports = __webpack_public_path__ + "img/20190812162228439.1e59c3c2.png";